import { render } from "./FormSubmissions.vue?vue&type=template&id=73782028"
import script from "./FormSubmissions.vue?vue&type=script&lang=js"
export * from "./FormSubmissions.vue?vue&type=script&lang=js"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__